<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'teleport',
    props: {
        /* 移动至哪个标签内，最好使用id */
        to: {
            type: String,
            default: 'body'
        }
    },
    mounted() {
        document.querySelector(this.to).appendChild(this.$el);
    },
    beforeDestroy() {
        // this.$el && document.querySelector(this.to).removeChild(this.$el)
    }
};
</script>
